export default "__VITE_ASSET__JAyWM2Ou__"